<template>
    <svg
        width="660"
        height="406"
        viewBox="0 0 660 406"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M320 170C320 163.373 325.373 158 332 158H648C654.627 158 660 163.373 660 170V394C660 400.627 654.627 406 648 406H332C325.373 406 320 400.627 320 394V170Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M320 170C320 163.373 325.373 158 332 158H648C654.627 158 660 163.373 660 170V394C660 400.627 654.627 406 648 406H332C325.373 406 320 400.627 320 394V170Z"
            fill="var(--et-colors-background)"
        />
        <path
            d="M344 190C344 185.582 347.582 182 352 182H384C388.418 182 392 185.582 392 190V222C392 226.418 388.418 230 384 230H352C347.582 230 344 226.418 344 222V190Z"
            fill="#F2F4F7"
        />
        <path
            d="M367.513 211.45L367.278 211.688M372.176 209.609L371.938 209.844M368 215.911C374.739 215.911 377.91 211.474 377.91 206C375.448 207.148 372.915 205.848 372.684 203.243C372.684 203.243 370.02 203.547 368.396 202.036C366.017 199.657 368 196.089 368 196.089C361.26 196.089 358.089 200.526 358.089 206C358.089 211.474 361.26 215.911 368 215.911ZM364.064 208.085C365.586 208.085 366.442 207.229 366.442 205.707C366.442 204.184 365.586 203.328 364.064 203.328C362.542 203.328 361.685 204.184 361.685 205.707C361.685 207.229 362.542 208.085 364.064 208.085Z"
            stroke="#101828"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="18"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="344" y="268.6">Cookies consent</tspan>
        </text>
        <path
            d="M630 286H350C346.686 286 344 288.686 344 292C344 295.314 346.686 298 350 298H630C633.314 298 636 295.314 636 292C636 288.686 633.314 286 630 286Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M544 306H350C346.686 306 344 308.686 344 312C344 315.314 346.686 318 350 318H544C547.314 318 550 315.314 550 312C550 308.686 547.314 306 544 306Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M629.78 203.781L614.219 188.219M614.219 203.781L629.78 188.219"
            stroke="#98A2B3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <g filter="url(#filter0_d_232_2059)">
            <path
                d="M344.5 350C344.5 345.858 347.858 342.5 352 342.5H478C482.142 342.5 485.5 345.858 485.5 350V374C485.5 378.142 482.142 381.5 478 381.5H352C347.858 381.5 344.5 378.142 344.5 374V350Z"
                fill="none"
                stroke="#D0D5DD"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="393.5" y="366.3">Adjust</tspan>
            </text>
        </g>
        <g filter="url(#filter1_d_232_2059)">
            <path
                d="M494.5 350C494.5 345.858 497.858 342.5 502 342.5H628C632.142 342.5 635.5 345.858 635.5 350V374C635.5 378.142 632.142 381.5 628 381.5H502C497.858 381.5 494.5 378.142 494.5 374V350Z"
                fill="var(--et-colors-brand)"
                stroke="#101828"
            />
            <text
                fill="var(--et-colors-background)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="541" y="366.3">Accept</tspan>
            </text>
        </g>
        <defs>
            <filter
                id="filter0_d_232_2059"
                x="342"
                y="341"
                width="146"
                height="44"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_2059"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_2059"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_232_2059"
                x="492"
                y="341"
                width="146"
                height="44"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_2059"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_2059"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
